import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { artImage, artThumb } from "../../decks/getCards";
import { primaryType } from "../../decks/cardDetails";
import {
  Modal,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import CardMUI from "@mui/material/Card";
import Card from "../hand/Card";
import { setViewingCemeteryOpponent } from "../../redux/CardSlice";
import { registerEnemyCemetery } from "./handDrag";
import "../../css/Card.css";
import { useUiModalOpen } from "../hooks/useUiChromeVisible";
import { ModalHideUiRow } from "../ui/HideUiButton";

const img = require("../../assets/pin_bellringer_angel.png");

const style = {
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "transparent",
  width: "40%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

export default function EnemyCemetery({ setHovering, ready }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const modalOpen = useUiModalOpen(open);
  const [cemeterySelected, setCemeterySelected] = useState(true);
  const [banishSelected, setBanishSelected] = useState(false);

  const reduxEnemyCemetery = useSelector((state) => state.card.enemyCemetery);
  const reduxEnemyArt = useSelector((state) => state.card.enemyArt);
  const reduxEnemyBanish = useSelector((state) => state.card.enemyBanish);

  const cemeteryTypeCounts = reduxEnemyCemetery.reduce(
    (counts, card) => {
      const type = primaryType(card);
      if (type === "Follower") counts.Follower += 1;
      else if (type === "Spell") counts.Spell += 1;
      else if (type === "Amulet") counts.Amulet += 1;
      return counts;
    },
    { Follower: 0, Spell: 0, Amulet: 0 },
  );

  const handleModalOpen = () => {
    if (
      (reduxEnemyCemetery.length > 0 || reduxEnemyBanish.length > 0) &&
      !ready
    ) {
      setOpen(true);
      dispatch(setViewingCemeteryOpponent(true));
    }
  };
  const handleModalClose = () => {
    setOpen(false);
    dispatch(setViewingCemeteryOpponent(false));
  };
  const handleCemeterySelected = () => {
    setCemeterySelected(true);
    setBanishSelected(false);
  };
  const handleBanishSelected = () => {
    setCemeterySelected(false);
    setBanishSelected(true);
  };

  return (
    <>
      <div
        ref={(el) => registerEnemyCemetery(el)}
        onClick={handleModalOpen}
        style={{
          // height: "160px",
          // width: "115px",
          borderRadius: "10px",
          border: "4px solid #1a20d6c8",
          cursor: `url(${img}) 55 55, auto`,
          position: "relative",
        }}
        className={"cardStyle"}
      >
        {reduxEnemyCemetery && reduxEnemyCemetery.length > 0 && (
          <img
            // height={"160px"}
            className={"cardStyle"}
            src={artThumb(reduxEnemyCemetery[0], reduxEnemyArt)}
            onError={(e) => {
              if (e.currentTarget.src.indexOf("/thumbs/") !== -1)
                e.currentTarget.src = artImage(reduxEnemyCemetery[0], reduxEnemyArt);
            }}
            alt={"cardback"}
          />
        )}
        <div
          style={{
            width: "50px",
            position: "absolute",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            top: "70%",
            right: "30%",
            color: "rgba(255, 255, 255, 1)",
            fontSize: "30px",
            fontFamily: "Noto Serif JP, serif",
          }}
        >
          {reduxEnemyCemetery.length || 0}
        </div>
      </div>

      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          "& > .MuiBackdrop-root": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Box sx={style}>
          <ModalHideUiRow />
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                checked={cemeterySelected}
                onChange={handleCemeterySelected}
                sx={{ fontFamily: "Noto Serif JP, serif", color: "white" }}
                value={cemeterySelected}
                control={<Radio />}
                label="Cemetery"
              />
              <FormControlLabel
                checked={banishSelected}
                onChange={handleBanishSelected}
                sx={{ fontFamily: "Noto Serif JP, serif", color: "white" }}
                value={banishSelected}
                control={<Radio />}
                label="Banish"
              />
            </RadioGroup>
          </FormControl>
          {cemeterySelected && (
            <Box
              sx={{
                display: "flex",
                gap: "18px",
                marginBottom: "8px",
                color: "white",
                fontFamily: "Noto Serif JP, serif",
                fontSize: "18px",
              }}
            >
              <span>Followers: {cemeteryTypeCounts.Follower}</span>
              <span>Spells: {cemeteryTypeCounts.Spell}</span>
              <span>Amulets: {cemeteryTypeCounts.Amulet}</span>
            </Box>
          )}
          <CardMUI
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              minHeight: "250px",
              padding: "7%",
              height: "500px",
              overflowY: "scroll",
              width: "100%",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
            variant="outlined"
          >
            {cemeterySelected &&
              reduxEnemyCemetery.map((card, idx) => (
                <div key={`card-${idx}`}>
                  <Card ready={ready} name={card} setHovering={setHovering} />
                </div>
              ))}
            {banishSelected &&
              reduxEnemyBanish.map((card, idx) => (
                <div key={`card-${idx}`} style={{ width: "115px" }}>
                  <Card
                    ready={ready}
                    name={card}
                    evolvedUsed={true}
                    setHovering={setHovering}
                  />
                </div>
              ))}
          </CardMUI>
        </Box>
      </Modal>
    </>
  );
}
